import { render, staticRenderFns } from "./sp-linkto.vue?vue&type=template&id=185478ee&scoped=true"
import script from "./sp-linkto.vue?vue&type=script&lang=js"
export * from "./sp-linkto.vue?vue&type=script&lang=js"
import style0 from "./sp-linkto.vue?vue&type=style&index=0&id=185478ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185478ee",
  null
  
)

export default component.exports